



































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { SelectOption } from "../../logic/types";

@Component
export default class ChipsInputField extends Vue {
  @Prop() options!: Array<string | SelectOption> | null

  inputValue = ''

  get findOptions(): Array<string | SelectOption> {
    if (this.options) {
      return this.options!.filter((option) => {
        if (typeof option === 'string') {
          return option.includes(this.inputValue)
        }
        return option.label.includes(this.inputValue)
      })
    }

    return []
  }

  @Emit('addWord')
  addWord(): string {
    return this.inputValue
  }

  handleAddWord(): void {
    if (this.inputValue) {
      this.addWord()
    }

    this.inputValue = ''
  }
}
